import "./Button.scss";

export default function Button({
  children,
  onClick,
  disabled,
  primary = true,
  className,
  type = "submit",
}) {
  const btnClass = `btn ${primary ? "btn-primary" : ""} ${
    disabled ? "btn-disabled" : ""
  }`;

  return (
    <button
      type={type}
      className={`${btnClass} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
